import { deleteSaveMedia as backendDeleteSaveMedia, uploadSaveImage as backendUploadSaveImage } from '../backend-api.js'

export class MediaAdapter {
  async uploadImage(uid: string, saveId: string, imageId: string, base64: string): Promise<string> {
    if (!base64.startsWith('data:image/')) return base64
    return backendUploadSaveImage(uid, saveId, imageId, base64)
  }

  async deleteSaveMedia(uid: string, saveId: string): Promise<void> {
    await backendDeleteSaveMedia(uid, saveId)
  }
}
